/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedSelectiveProcessStatusList200,
  GetApiV1CourseregistrationSharedSelectiveProcessStatusList401,
  GetApiV1CourseregistrationSharedSelectiveProcessStatusList500,
  GetApiV1CourseregistrationSharedSelectiveProcessStatusListQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedSelectiveProcessStatusList.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedSelectiveProcessStatusList200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedSelectiveProcessStatusList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedSelectiveProcessStatusList401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedSelectiveProcessStatusList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedSelectiveProcessStatusList500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedSelectiveProcessStatusList500>;

export const getApiV1CourseregistrationSharedSelectiveProcessStatusListQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationSharedSelectiveProcessStatusList200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedSelectiveProcessStatusListQueryResponse>;
